"use strict";
var zip_1 = require('../operators/zip');
exports.zip = zip_1.zipStatic;
//# sourceMappingURL=zip.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/observable/zip.js
// module id = 763
// module chunks = 7